// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 760px) {
  .btn-custom {
    color: black;
    border: solid black 1px;
  }
  .btn-custom:hover {
    background-color: none;
    color: white;
  }
}

  /* HeroSection.css */
@media (max-width: 1024px) {
  .container {
    flex-direction: column;
    
  }
}
@media (min-width: 1092px) {
  .hero-heading {
    font-size: 50px;
    line-height: 60px;
  } 
  @media (min-width: 1200px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
  @media (min-width: 1300px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
  @media (min-width: 1400px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
  @media (min-width: 1500px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
  @media (min-width: 1600px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
  @media (min-width: 1700px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
  @media (min-width: 1800px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
  @media (min-width: 1900px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
  @media (min-width: 2000px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
  @media (min-width: 2200px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
  @media (min-width: 2100px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
  @media (min-width: 2300px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
  @media (min-width: 2400px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
  @media (min-width: 2500px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
  @media (min-width: 2600px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
  @media (min-width: 2700px){
    .hero-heading{
      font-size: 50px;
      line-height: 70px;
    }
  }
 }
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE;IACE,YAAY;IACZ,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,YAAY;EACd;AACF;;EAEE,oBAAoB;AACtB;EACE;IACE,sBAAsB;;EAExB;AACF;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;EACA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;CACD","sourcesContent":["@media (max-width: 760px) {\n  .btn-custom {\n    color: black;\n    border: solid black 1px;\n  }\n  .btn-custom:hover {\n    background-color: none;\n    color: white;\n  }\n}\n\n  /* HeroSection.css */\n@media (max-width: 1024px) {\n  .container {\n    flex-direction: column;\n    \n  }\n}\n@media (min-width: 1092px) {\n  .hero-heading {\n    font-size: 50px;\n    line-height: 60px;\n  } \n  @media (min-width: 1200px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n  @media (min-width: 1300px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n  @media (min-width: 1400px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n  @media (min-width: 1500px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n  @media (min-width: 1600px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n  @media (min-width: 1700px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n  @media (min-width: 1800px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n  @media (min-width: 1900px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n  @media (min-width: 2000px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n  @media (min-width: 2200px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n  @media (min-width: 2100px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n  @media (min-width: 2300px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n  @media (min-width: 2400px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n  @media (min-width: 2500px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n  @media (min-width: 2600px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n  @media (min-width: 2700px){\n    .hero-heading{\n      font-size: 50px;\n      line-height: 70px;\n    }\n  }\n }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
